<h2 mat-dialog-title class="copo-color-orange" translate>dialog.delete.title</h2>
<mat-dialog-content>
	<div class="copo-simple-dialog-content" *ngIf="userRole !== 'dsu'">
		<div>
			<span translate>dialog.delete.description</span><b><span class="featured"> {{data.title}}</span></b>?
		</div>
	</div>
	<div class="copo-simple-dialog-content" *ngIf="userRole === 'dsu' && showAdminDeletionDialog">
		<div>
			<b><span class="featured"> {{data.title}}({{data.userId}}) </span></b><span translate>administrator.message </span><b><span class="featured"> {{organizationNameAndId}}</span></b>
		</div>
		<p translate>select.new.administrator</p>
		<div>
			<mat-form-field>
				<mat-label class="copo-card-content-mat-label" translate>promote.user.message</mat-label>
				<mat-select class="copo-card-content-data" [formControl]="selectedNewAdmin">
					<mat-option *ngFor="let user of dummyUserList" [value]="user.id">{{user.firstName}} {{ user.lastName}}
					</mat-option>
				</mat-select>
				<mat-error *ngIf="showAdminDeletionDialog && selectedNewAdmin.hasError('required')" translate>ecall-off.required</mat-error>
			</mat-form-field>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions>
	<button type="button" mat-button [disabled]="isSubmitting" [mat-dialog-close]="false" class="save-cancel-button-block copo-button-font">
		<span translate>dashboard.cancel</span>
	</button>
	<button type="submit" mat-button class="copo-blue-dark-grey-button" [disabled]="isSubmitting" (click)="onValidateClick()">
		<span translate>dashboard.validate</span>
	</button>
</mat-dialog-actions>